<template>
  <div class="OSL-Home">
    <swiper ref="mySwiper" :options="swiperOptions">
      <!-- <swiper-slide>
                <Slide1></Slide1>
      </swiper-slide>-->
      <swiper-slide>
        <Slide2></Slide2>
      </swiper-slide>
      <swiper-slide>
        <Slide6></Slide6>
      </swiper-slide>
      <swiper-slide>
        <Slide3></Slide3>
      </swiper-slide>
      <swiper-slide>
        <Slide4></Slide4>
      </swiper-slide>
      <swiper-slide>
        <Slide5></Slide5>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
    <span class="mouse">
      <span class="mouse__wheel"></span>
    </span>
  </div>
</template>
<script>
// import Slide1 from "./Slide1"
import Slide2 from "./Slide2";
import Slide3 from "./Slide3";
import Slide4 from "./Slide4";
import Slide5 from "./Slide5";
import Slide6 from "./Slide6";
export default {
  name: "Product",
  components: {
    // Slide1,
    Slide2,
    Slide3,
    Slide4,
    Slide5,
    Slide6
  },
  data() {
    return {
      swiperOptions: {
        initialSlide: 0,
        direction: "vertical",
        mousewheel: {
          invert: false
        }
      }
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    }
  },
  mounted() {
    console.log("Current Swiper instance object", this.swiper);
    // this.swiper.slideTo(3, 1000, false)
  }
};
</script>
<style lang="scss" scoped>
.OSL-Home {
  min-width: 1400px;
  height: 100%;
  padding-top: 80px;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;

  .mouse {
    position: fixed;
    box-sizing: border-box;
    left: 50%;
    bottom: 20px;
    width: 30px;
    height: 48px;
    border-radius: 15px;
    border: 2px solid rgba(0, 0, 0, 0.5);
    transform: translateX(-50%) translateZ(0);
    z-index: 999;

    .mouse__wheel {
      position: absolute;
      left: 50%;
      margin-left: -2px;
      top: 8px;
      width: 4px;
      height: 9px;
      background: rgba(0, 0, 0, 0.5);
      border-radius: 2px;
      animation: mouse-wheel 1.25s infinite linear;
      transform-origin: 50% 0%;

      @keyframes mouse-wheel {
        0% {
          transform: scaleY(0.4) translateY(0);
        }

        20% {
          transform: scaleY(1) translateY(0);
        }

        60% {
          transform: scaleY(0.4) translateY(12px);
        }

        100% {
          transform: scaleY(0.4) translateY(0);
        }
      }
    }
  }
}
</style>